module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABV0lEQVQ4jbWVvUoEMRRGj8OIW4iFCpaCxRWsFOwEbRat9A30BRZsbBUWrG0E2X59A60UGwU7wa2ESSF2KugWq4ViIxcyEEKGHWfiVyaTk+/m/sxIlmUUaAbYAdaBJWDKrveBe+AS6IrIS+hwCDwOtIEW0Ci61eoH6AD7IvLhbiTehwLcAXsloKpRYBfoGWMWisAKvQXmSwB9zQHXLjwHa/hnwHQFaC49e26MmXDB7YpOQ84PscnT7D+VfNMy0oTOJrakYkGxCd1ObJ3G1kZqiz+kL+B7yIVjBdEupk5HuboBmva9hoV9Bax665N+g0STOn4PuFYHgxpP0U/tQGkGNhs1qqWX2CkVWxcK7toKiCVN+KmCX4GTiOCOiDy7s6Jw4v9Bj8ABzhD6BLaAtxpQPbspIgO8eWyAlYrO1emaiDzkC36DKHwZOCqZUE3UsbawC1X9z88U+AV8PVHZgnDWmAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/family/icon/family_equipment_del.png
// module id = vySq
// module chunks = 1